import apiService from 'src/shared/config/apiService';
import { Sampling } from 'src/shared/types/sampling';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

const getProductSamplings = async (id: string) => {
  try {
    const response = await apiService.get<Sampling[]>(
      `/products/${id}/samples`
    );

    return response;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default getProductSamplings;
